<template>
  <v-bottom-nav
    :active.sync="page"
    class="hidden-md-and-up"
    color="#1c456d"
    :value="true"
    fixed
    dark dense
    shift
    v-if="profile"
  >
    <v-btn small dark value="transfers">
      <span>Транзакции</span>
      <v-icon>receipt</v-icon>
    </v-btn>
    <v-btn small dark value="messages">
      <span>Сообщения</span>
      <v-icon>email</v-icon>
    </v-btn>
    <v-btn small dark value="statements">
      <span>Заявления</span>
      <v-icon>local_offer</v-icon>
    </v-btn>
    <v-btn small dark value="events">
      <span>Проходы</span>
      <v-icon>lock_open</v-icon>
    </v-btn>
    <v-btn small dark value="settings">
      <span>Настройки</span>
      <v-icon>settings</v-icon>
    </v-btn>
    <v-btn small hidden class="hidden-lg-and-down" value="other">
    </v-btn>
  </v-bottom-nav>
</template>

<script>
export default {
  name: 'mobile-bottom-nav',
  data: () => ({
    page: 'other',
    pages: ['transfers', 'messages', 'settings']
  }),
  computed: {
    routeName () {
      return this.$route.name
    },
    profile () {
      return this.$store.state.profile
    }
  },
  watch: {
    routeName (val) {
      // см внешний роутинг. азер нужен чтобы панелька не баговала на нуллах
      this.page = this.pages.includes(val) ? val : 'other'
    },
    page (val) {
      if (
        val !== this.routeName &&
        this.routeName !== null &&
        this.pages.includes(val)
      ) {
        // переход если ткнули по иконке
        this.$router.push({ name: val })
      }
    }
  }
}
</script>
